import React from "react"
import PropTypes from "prop-types"

const DownloadIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 14 12">
    <path d="M14,7v5H0V7H2v3H12V7h2ZM7,8.41L2.81,4.27l1-1L6.29,5.71V0H7.71V5.71l2.46-2.43,1,1Z" />
  </svg>
)

DownloadIcon.propTypes = {
  style: PropTypes.object
}

export default DownloadIcon



// WEBPACK FOOTER //
// ./src/components/icons/download-icon.jsx